<template>
  <div style="box-sizing: border-box">
    <van-search
      style="width: 100%; box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.5)"
      v-model="value"
      show-action
      clearable
      placeholder="请输入关联卡号"
      @search="seach"
    >
      <template #action>
        <div @click="seach">搜索</div>
      </template>
    </van-search>

    <div style="padding: 10px">
      <div>
        <Card @fatherMethod="getAll" :msg="fom"></Card>
      </div>
      <div class="header" @click="add">
        <span
          style="
            margin-left: 36%;
            display: flex;
            width: 20px;
            height: 20px;
            border-radius: 50%;
            border: 1px dashed white;
          "
        >
          <van-icon name="plus" color="white" size="20" />
        </span>
        <span
          style="
            line-height: 20px;
            font-size: 16px;
            text-align: center;
            margin-left: 10px;
            color: white;
          "
        >
          添加卡
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  import Card from "@/components/Card.vue";
  import { cardSave, search } from "@/api/apn";

  export default {
    name: "Switch",
    data() {
      return {
        activeName: "a",
        card: 1,
        value: "",
        fom: [],
      };
    },
    created() {},
    mounted() {
      this.getAll();
    },

    methods: {
      getAll() {
        cardSave(this.value).then((res) => {
          if (res.status) {
            console.log(res);
            res.data.forEach((element) => {
              if (element.sumFlow == 0) {
                element.cc = 0;
              } else if (element.surplusFlow < 0) {
                element.cc = 100;
              } else {
                element.cc = Math.floor(
                  (element.consumeFlow / element.sumFlow) * 100
                );
              }
            });

            this.fom = res.data;
          }
        });
      },
      seach() {
        search(this.value).then((res) => {
          if (res.status) {
            res.data.forEach((element) => {
              if (element.sumFlow == 0) {
                element.cc = 0;
              } else if (element.surplusFlow < 0) {
                element.cc = 100;
              } else {
                element.cc = Math.floor(
                  (element.consumeFlow / element.sumFlow) * 100
                );
              }
            });
            this.fom = res.data;
          }
        });
      },
      copy() {
        var e = document.getElementById("target");
        e.select(); // 选择对象
        document.execCommand("Copy"); // 执行浏览器复制命令
        alert("内容复制成功！");
      },
      add() {
        this.$router.push("/addcard");
      },
    },
    components: {
      Card,
    },
  };
</script>

<style lang="scss" scoped>
  .header {
    display: flex;
    margin: 10px 0;
    padding: 10px;
    box-sizing: border-box;
    width: 100%;
    background: #1989fa;
    text-align: center;
    border-radius: 5px;

    box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.1);
  }

  .detail {
    padding: 5px;
    box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.1);
  }
</style>
